import axios from "../../../utils/axiosInstance";

export const getViewerLiveSyncUrlApi = async (dataParams) => {
  try {
    const resData = await axios.post(
      `/api/viewer/viewerLiveShareUrl`,
      dataParams
    );
    return resData;
  } catch (err) {
    throw err;
  }
};

export const downloadAnnotationApi = async (dataParams) => {
  try {
    const resData = await axios.post(
      `/api/viewer/downloadAnnotation`,
      dataParams
    );
    return resData;
  } catch (err) {
    throw err;
  }
};

export const updateDescriptionAPI = async (dataParams) => {
  try {
    const resData = await axios.post(
      "/api/viewer/updateAnnotationDescription",
      dataParams
    );
    return resData;
  } catch (error) {
    throw error;
  }
};
export const setActivityLogApi = async (dataParams) => {
  try {
    let endPoint;
    if (dataParams.type === "add") {
      endPoint = "/api/viewer/addSlideReviewLog";
    } else {
      endPoint = "/api/viewer/updateSlideReviewLog";
    }
    const resData = await axios.post(endPoint, dataParams);
    return resData;
  } catch (err) {
    throw err;
  }
};

export const getActivityLogApi = async (dataParams) => {
  try {
    const resData = await axios.get("/api/viewer/viewerReviewLog", {
      params: dataParams,
    });
    return resData;
  } catch (err) {
    throw err;
  }
};

export const getHeatMapDataApi = async (dataParams) => {
  try {
    const resData = await axios.post(
      "/api/aiAnalytics/generateHeatMap",
      dataParams
    );
    return resData;
  } catch (err) {
    throw err;
  }
};

export const livesynStopApi = async (dataParams) => {
  try {
    const resData = await axios.get("/api/viewer/liveSyncStop", dataParams);
    return resData;
  } catch (err) {
    throw err;
  }
};

export const getSlideLabelsApi = async (dataParams) => {
  try {
    const resData = await axios.get("/api/viewer/getSlideLabels", {
      params: dataParams,
    });
    return resData;
  } catch (err) {
    throw err;
  }
};

export const setViewerLabelsApi = async (dataParams) => {
  try {
    const resData = await axios.post("/api/viewer/setViewerLabels", dataParams);
    return resData;
  } catch (err) {
    throw err;
  }
};

// SectionStar block images.
//
// Resolves to { data: { success, images, resolved } } on success, or
// { data: { success: false, reason } } with HTTP 200 when the four upstream IDs
// cannot be resolved for this slide — which is the ordinary case, since most
// slides did not come from SectionStar. A 502 (upstream unreachable) rejects and
// is caught by getBlockImagesAction as "request_failed".
export const getBlockImagesApi = async (slideId) => {
  return axios.get("/api/viewer/sectionstar-block-images", {
    params: { slideId },
  });
};
